module.exports = __webpack_public_path__ + "static/img/rank_180.b83e362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_180.png
// module id = wu0h
// module chunks = 1